import { render, staticRenderFns } from "./RentalBoxOnHand_Component.vue?vue&type=template&id=09224122&scoped=true&"
import script from "./RentalBoxOnHand_Component.vue?vue&type=script&lang=js&"
export * from "./RentalBoxOnHand_Component.vue?vue&type=script&lang=js&"
import style0 from "./RentalBoxOnHand_Component.vue?vue&type=style&index=0&id=09224122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09224122",
  null
  
)

export default component.exports